export default "__VITE_ASSET__ZKNBNAUc__"